import React from 'react';
import { useField } from 'formik';
import Form from 'react-bootstrap/Form';

import styles from '../step2.module.scss';

export enum InputAlign {
  LEFT = 'left',
  CENTER = 'center',
}

interface BreedProps {
  // name: string;
  // inputAlign?: InputAlign;
}

const Breed: React.FC<BreedProps> = props => {
  const [field, meta, helpers] = useField('breed');
  const { setValue, setTouched } = helpers;
  const breedParentClasses = [styles.breedParent];

  if (props.inputAlign === InputAlign.CENTER) {
    breedParentClasses.push(styles.breedParentCenter);
  }

  const setBreed = (breed: string) => {
    setValue(breed);
    setTouched(true);
  };

  return (
    <Form.Group controlId="formBreed" className={'align-col-cen'}>
      <Form.Label>{props.name ? `${props.name}'s` : ''} Breed</Form.Label>
      <Form.Control
        type="text"
        name="breed"
        onChange={e => setBreed(e.target.value)}
        value={meta.value}
        placeholder="Type your dog’s breed here (optional)"
        maxLength={30}
      />
      <span className='step-info-message'>For mixed, please type 'mixed breed' or main breed(s)</span>
    </Form.Group>
  );
};

export default Breed;
